import type { TaggingActionPayload, TaggingFeedback, TaggingViewPayload } from '../../models'

import type { TaggingService } from '../interfaces/tagging.service'

import { TaggingTypeEnum } from '../../enums'
import { ApiService } from '../api.service'

export class TaggingApiService extends ApiService implements TaggingService {
  private static readonly ENDPOINTS = {
    [TaggingTypeEnum.VIEW]: '/view',
    [TaggingTypeEnum.ACTION]: '/action',
    feedback: '/feedback',
  }

  public constructor(protected readonly BASE_URL: string) {
    super(BASE_URL)
  }

  tagView(instance: string, payload: TaggingViewPayload, sessionId: string): Promise<void> {
    return this.tag(TaggingTypeEnum.VIEW, instance, payload, sessionId)
  }

  tagAction(instance: string, payload: TaggingActionPayload, sessionId: string): Promise<void> {
    return this.tag(TaggingTypeEnum.ACTION, instance, payload, sessionId)
  }

  async submitFeedback(
    instance: string,
    payload: TaggingFeedback,
    sessionId: string,
  ): Promise<void> {
    const endpointUrl = `${TaggingApiService.ENDPOINTS.feedback}/${instance}`
    const contentType = this.CONTENT_TYPES.JSON
    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        [this.REQUEST_HEADERS.CONTENT_TYPE]: contentType,
      },
      body: this.encodeRequestBody({ ...payload, sessionId }, contentType),
    }
    await this.fetch(endpointUrl, undefined, requestInit)
  }

  private async tag(
    type: TaggingTypeEnum,
    instance: string,
    payload: TaggingViewPayload | TaggingActionPayload,
    sessionId: string,
  ): Promise<void> {
    const requestParams = {
      ...payload,
      session_id: sessionId,
    }
    const requestInit: RequestInit = {
      method: 'POST',
    }
    try {
      await this.fetch<void>(
        `${TaggingApiService.ENDPOINTS[type]}/${instance}`,
        requestParams,
        requestInit,
      )
    } catch (error) {
      console.error(error)
    }
  }
}
